<script setup>
defineProps({
  theme: {
    type: String,
    required: false,
    default: 'primary',
    validator: (value) =>
      ['primary', 'secondary', 'tertiary', 'accent', 'transparent'].includes(
        value,
      ),
  },
  content: {
    type: String,
    required: true,
  },
})
</script>

<template>
  <div class="h-3 w-3">
    <IconInfo
      v-tippy="{
        placement: 'left',
        arrow: true,
        flip: true,
        flipBehavior: ['left', 'top'],
      }"
      class="h-full w-full"
      :class="{
        'text-secondary': theme === 'primary',
        'text-secondary group-hover:text-accent': theme === 'accent',
        'text-accent': theme === 'secondary',
      }"
      :content="content"
    />
  </div>
</template>
